<template>
  <div>
    <add-host modal-id="add-host">
      <div slot="title">Add Hosting Account</div>
      <div slot="form">
        <div class="row">
          <div class="col-lg-12">
            <input type="text" class="form-control" v-model="host['name']" placeholder="Name">
          </div>
          <div class="col-lg-12">
            <v-select :options="f.clients" label="name" index="id" placeholder="Client"></v-select>
          </div>
        </div>
      </div>
    </add-host>
  </div>
</template>
<script>
import Form from '../../../Helpers/Modal/Form'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      host: {}
    }
  },
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  components: {
    addHost: Form
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Accounts/Hosts/AddHostModal.vue